<script setup lang="ts">
import { computed } from 'vue';
import gerentesSelect from '~/graphql/gerentesSelect.graphql';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="transferencia-responsavel-processual-para-outra-area/transferencia-responsavel-processual-para-outra-area-nao-aprovada"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    :submit-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-form-item
        label="Solicitar novamente?"
        name="solicitarNovamente"
        :rules="[
          {
            message: 'Essa opção é obrigatória',
            required: true,
            trigger: 'change',
          },
        ]"
      >
        <a-radio-group v-model:value="model.solicitarNovamente">
          <a-radio-button :value="true"> Sim </a-radio-button>
          <a-radio-button :value="false"> Não </a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        v-if="model.solicitarNovamente"
        name="gerente"
        label="Gerente aprovador"
        :rules="[
          {
            message: 'Gerente aprovador é obrigatório',
            required: true,
            trigger: 'change',
            type: 'object',
          },
        ]"
      >
        <GqlSelect
          v-model:value="model.gerente"
          :query="gerentesSelect"
          placeholder="Selecione o gerente"
        />
      </a-form-item>

      <a-form-item
        v-if="model.solicitarNovamente"
        label="Observação"
        name="observacao"
      >
        <a-textarea v-model:value="model.observacao" :rows="4" />
      </a-form-item>
    </template>
  </CompromissoForm>
</template>
